// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._1r04idpf{inset:0}
._v56414ka{transition:opacity .22s}._1pby1fw0{z-index:700}
._kqsw1n9t{position:fixed}`, "",{"version":3,"sources":["webpack://./node_modules/@atlassian/search-ai/node_modules/@atlaskit/onboarding/dist/esm/styled/blanket.compiled.css"],"names":[],"mappings":";AACA,WAAW,OAAO;AAClB,WAAW,uBAAuB,CAAC,WAAW,WAAW;AACzD,WAAW,cAAc","sourcesContent":["\n._1r04idpf{inset:0}\n._v56414ka{transition:opacity .22s}._1pby1fw0{z-index:700}\n._kqsw1n9t{position:fixed}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
